"use client";
import SectionTitle from "@/shared/app/ui/text/PageSectionTitle";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion, Variants } from "framer-motion";
import Image from "next/image";

const container: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      duration: 0.5,
      ease: "easeOut",
    },
  },
};

const item: Variants = {
  hidden: { opacity: 0, y: 15 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};
type SolutionCardProps = {
  label: string;
  title: string;
  cooperations: string[];
};

const SolutionCard = ({ label, title, cooperations }: SolutionCardProps) => {
  return (
    <motion.div
      variants={item}
      className="flex flex-col bg-white border-[1px] border-[#C8C8C8]/40 rounded-2xl md:px-8 md:py-4 px-5 py-2 shadow-sm hover:shadow-md transition-all duration-300 relative"
    >
      <div
        className="bg-[#4B7EF4] text-[13px] md:text-[15px] text-white absolute top-[-12px] left-1/2 -translate-x-1/2 leading-7 px-4 py-1 rounded-full flex items-center"
        style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
      >
        {label}
        <div className="relative w-4 h-5 overflow-hidden ml-2">
          <Image
            src="/assets/images/page/service/solution/pin.png"
            alt="pinIcon"
            fill
            className="object-contain"
          />
        </div>
      </div>

      <h3
        className="text-lg md:text-2xl mb-5 text-center md:pb-6 md:pt-12 pt-7 pb-0 text-[#4B7EF4] tracking-tight"
        style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
      >
        {title}
      </h3>

      <ul className="flex flex-col gap-3 md:gap-6 border-t-[1px] border-[#E4E4E4]/80 md:py-9 py-5">
        {cooperations.map((coop, index) => (
          <li
            key={index}
            className="flex md:px-5 px-2 items-center space-x-2 justify-center"
          >
            <div>
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="text-[#4B7EF4] md:text-2xl text-lg"
              />
            </div>
            <p
              className="tracking-tighter text-midGray-30 text-[15px]  md:text-lg leading-7"
              style={{ fontFamily: '"pre-Medium", sans-serif' }}
            >
              {coop}
            </p>
          </li>
        ))}
      </ul>
    </motion.div>
  );
};
export default function SolutionCooperationSection() {
  const solutions = [
    {
      label: "Solution 01",
      title: "문제 발굴",
      cooperations: ["지역 내 사회문제 조사", "수요 기반 발굴 워크숍"],
    },
    {
      label: "Solution 02",
      title: "ICT 컨설팅",
      cooperations: ["기술 컨설팅 지원", "서비스 고도화 방안 제시"],
    },
    {
      label: "Solution 03",
      title: "ICT 지원 연계",
      cooperations: ["기관·기업 간 매칭", "협력 네트워크 구축"],
    },
    {
      label: "Solution 04",
      title: "ICT 시스템 개발",
      cooperations: ["시스템 설계 및 구축", "운영 및 기술 지원"],
    },
  ];
  return (
    <div className="border-t border-[#ECECEC] mt-[-2px]">
      <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-14 md:py-20">
        <SectionTitle
          align="left"
          label="Bespoke Solutions"
          title={
            <>
              기업과 IT 솔루션을 잇는
              <br />
              맞춤형 협업
            </>
          }
          description={
            <>
              다양한 문제를 해결하고 있는 기업들과
              <br />
              필요한 IT 비용 마련을 위한 컨설팅 및 협업
            </>
          }
          colorMode="light"
        />

        {/* 솔루션 컨테이터 */}
        <div className="my-24 md:my-40">
          {/* <motion.div
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8 md:gap-10 xl:gap-[14px] w-full"
          > */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8 md:gap-10 xl:gap-[14px] w-full">
            {solutions.map((item, i) => (
              <SolutionCard key={i} {...item} />
            ))}
          </div>
          {/* </motion.div> */}
        </div>
        {/*  */}
      </div>
    </div>
  );
}
